<template>
  <div ref="scheduler"></div>
</template>

<script>
import 'dhtmlx-scheduler'
export default {
  name: 'MeetingSchedulerCalendar',
  props: {
    events: {
      type: Array,
      default () {
        return {events: []}
      }
    }
  },
  mounted: function () {
    console.log('--scheduler--', scheduler)

    scheduler.skin = "material";
    scheduler.config.header = [
      "day",
      "week",
      "month",
      "date",
      "prev",
      "today",
      "next"
    ];
    scheduler.config.dblclick_create = false;
    scheduler.config.drag_resize = false;
    scheduler.config.edit_on_create = false;
    scheduler.config.readonly = true;
    scheduler.config.hour_date = '%h:%i %A';
    scheduler.config.drag_create = false;
    scheduler.config.drag_move = false;

    let _this = this
    scheduler.templates.event_bar_text = function(start,end,event){
      return '<span class="meeting-name-calendar">' + event.roomId + '</span>' + `<span class="user-status-calendar user-status-${event.statusUser}">` + _this.$i18n.t(`header_approveMeeting_userStatus_${event.statusUser}`) + '</span>';
    };

    // scheduler.templates.event_bar_date = (start,end,ev) => {
    //   return "<b>"+scheduler.templates.event_date(start)+"</b> " + "- " + "<b>"+scheduler.templates.event_date(end)+"</b> ";
    // };

    scheduler.attachEvent("onDblClick", function(){
      console.log('0000')
    });

    scheduler.attachEvent("onClick", this.onEventClick);

    scheduler.templates.event_class = function(start,end,ev){
      return "custom-event-class";
    };


    scheduler.init(this.$refs.scheduler, new Date, "month");
    scheduler.parse(this.$props.events);
    console.log('scheduler', scheduler)
  },
  methods:{
    onEventClick(val) {
      const event = this.events.find(item => item.id === Number(val))
      this.$emit('eventClick', event)
    },
    closeScheduler(){
      scheduler.clearAll();
    }
  }
}
</script>

<style lang="less">
@import "~dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css";
.meeting-name-calendar{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width:100%;
  margin-left:5px;
}
.user-status-calendar{
  float:right;
  margin-right:0;
  min-width:50px;
  text-align:right;
}
.custom-event-class {
  font-size:12px;
  letter-spacing: 0;
  display:flex;
  padding-left:6px;
}
.user-status-approved{
  color: #67c23a;
}
.user-status-invite {
  color: #409eff;
}
.user-status-host {
  color: #409eff;
}
.user-status-decline {
  color: #f56c6c;
}
.user-status-maybe {
  color: #e6a23c;
}
</style>

